var classof = require('../internals/classof');

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/to-string.js
// module id = 361
// module chunks = 0